<template>
    <div class="container">
        <container :active_path="path" :plate="'云项目'">
            <div class="base-warp">
                <div class="head">
                    <el-form ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="名称">
                            <el-input v-model="keyword" placeholder="输入名称"></el-input>
                        </el-form-item>
                        <el-form-item label="团队类型">
                            <el-select v-model="teamtype" value-key="" placeholder="请选择" clearable filterable >
                                <el-option label="自销团队" value="自销团队"></el-option>
                                <el-option label="代理团队" value="代理团队"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否上架">
                            <el-select v-model="putaway" value-key="" placeholder="请选择" clearable filterable >
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search">搜索</el-button>
                            <consultant-apply></consultant-apply>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-radio-group v-model="activeTab" @change="changetabs" size="small">
                        <el-radio-button label="团队">查看团队</el-radio-button>
                        <el-radio-button label="个人">查看置业顾问</el-radio-button>
                    </el-radio-group>
                    <div class="warp" v-if="activeTab=='团队'">
                        <consultant-team-cell :teams="team.value"></consultant-team-cell>
                        <el-pagination class="page-tion"
                            @current-change="tcurrentChange"
                            layout="prev, pager, next"
                            :page-size="team.pagesize"
                            :total="team.total" background>
                        </el-pagination>
                    </div>
                    <div class="warp" v-if="activeTab=='个人'">
                        <consultant-cell :consultants="personage.value"></consultant-cell>
                        <el-pagination class="page-tion"
                            @current-change="pcurrentChange"
                            layout="prev, pager, next"
                            :page-size="personage.pagesize"
                            :total="personage.total" background>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import ConsultantApply from '../../../components/consultant-apply.vue';
import ConsultantCell from '../../../components/consultant-cell.vue';
import ConsultantTeamCell from '../../../components/consultant-team-cell.vue';
import container from "../../../components/container.vue";
export default {
    components: {
        container,
        ConsultantTeamCell,
        ConsultantCell,
        ConsultantApply,
    },
    data() {
        return {
            path: '/project/user',
            keyword: '',
            putaway: '',
            teamtype: '',
            activeTab: '团队',
            team: {
                pageNo: 1,
                pagesize: 14,
                total: 0,
                value: [],
            },
            personage: {
                pageNo: 1,
                pagesize: 14,
                total: 0,
                value: [],
            },
        }
    },
    mounted () {
        this.getTeams();
        this.getpersonage();
    },
    methods: {
        search() {
            this.team.pageNo = 1;
            this.personage.pageNo = 1;
            this.getTeams();
            this.getpersonage();
        },
        getTeams() {
            var params = {
                keyword: this.keyword,
                teamtype: this.teamtype,
                putaway: this.putaway,
                pagesize: this.personage.pagesize,
                pageNo: this.personage.pageNo
            };

            this.$api.getConsultantTeamList(params).then(
                data=>{
                    let {list, total} = data;
                    this.team.value = list;
                    this.team.total = total;
                }
            )
        },
        getpersonage() {
            var params = {
                keyword: this.keyword,
                teamtype: this.teamtype,
                putaway: this.putaway,
                pagesize: this.team.pagesize,
                pageNo: this.team.pageNo
            };

            this.$api.getConsultantList(params).then(
                data=>{
                    let {list, total} = data;
                    this.personage.value = list;
                    this.personage.total = total;
                }
            )
        },
        changetabs() {
            
        },
        tcurrentChange(page) {
            this.team.pageNo = page;
            this.getTeams();
        },
        pcurrentChange(page) {
            this.personage.pageNo = page;
            this.getpersonage();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>